export const AEAT_CODES: any = [
    {
        "codigo":"01801",
        "nombre":"Dependencia de Aduanas e Impuestos Especiales de Araba\/Álava"
    },
    {
        "codigo":"02801",
        "nombre":"Dependencia de Aduanas e Impuestos Especiales de Albacete"
    },
    {
        "codigo":"03001",
        "nombre":"Administración de Aduanas e Impuestos Especiales del Aeropuerto de Alicante\/Alacant"
    },
    {
        "codigo":"03801",
        "nombre":"Dependencia de Aduanas e Impuestos Especiales de Alicante\/Alacant (incluida la Oficina Gestora de Impuestos Especiales)"
    },
    {
        "codigo":"04801",
        "nombre":"Dependencia de Aduanas e Impuestos Especiales de Almería"
    },
    {
        "codigo":"05801",
        "nombre":"Dependencia de Aduanas e Impuestos Especiales de Ávila"
    },
    {
        "codigo":"06801",
        "nombre":"Dependencia Regional de Aduanas e Impuestos Especiales de Extremadura"
    },
    {
        "codigo":"07001",
        "nombre":"Administración de Aduanas e Impuestos Especiales de Palma de Mallorca"
    },
    {
        "codigo":"07020",
        "nombre":"Administración de Aduanas e Impuestos Especiales de Eivissa"
    },
    {
        "codigo":"07030",
        "nombre":"Administración de Aduanas e Impuestos Especiales de Maó-Mahón"
    },
    {
        "codigo":"07801",
        "nombre":"Dependencia Regional de Aduanas e Impuestos Especiales de Illes Balears (incluida la Oficina Gestora de Impuestos Especiales)"
    },
    {
        "codigo":"08001",
        "nombre":"Administración de Aduanas e Impuestos Especiales del Aeropuerto de Barcelona-El Prat: con sede en El Prat de Llobregat"
    },
    {
        "codigo":"08801",
        "nombre":"Dependencia Regional de Aduanas e Impuestos Especiales de Cataluña"
    },
    {
        "codigo":"09801",
        "nombre":"Dependencia de Aduanas e Impuestos Especiales de Burgos"
    },
    {
        "codigo":"10801",
        "nombre":"Dependencia de Aduanas e Impuestos Especiales de Cáceres"
    },
    {
        "codigo":"11801",
        "nombre":"Dependencia de Aduanas e Impuestos Especiales de Cádiz"
    },
    {
        "codigo":"11802",
        "nombre":"Dependencia de Aduanas e Impuestos Especiales de Algeciras"
    },
    {
        "codigo":"11803",
        "nombre":"Administración de Aduanas e Impuestos Especiales de La Línea de la Concepción"
    },
    {
        "codigo":"12801",
        "nombre":"Dependencia de Aduanas e Impuestos Especiales de Castellón\/Castelló"
    },
    {
        "codigo":"13801",
        "nombre":"Dependencia de Aduanas e Impuestos Especiales de Ciudad Real"
    },
    {
        "codigo":"14801",
        "nombre":"Dependencia de Aduanas e Impuestos Especiales de Córdoba"
    },
    {
        "codigo":"15007",
        "nombre":"Administración de Aduanas e Impuestos Especiales del Aeropuerto de Santiago de Compostela"
    },
    {
        "codigo":"15021",
        "nombre":"Administración de Aduanas e Impuestos Especiales de Ferrol"
    },
    {
        "codigo":"15801",
        "nombre":"Dependencia Regional de Aduanas e Impuestos Especiales de Galicia (incluida la Oficina Gestora de Impuestos Especiales)"
    },
    {
        "codigo":"16801",
        "nombre":"Dependencia de Aduanas e Impuestos Especiales de Cuenca"
    },
    {
        "codigo":"17600",
        "nombre":"Dependencia de Aduanas e Impuestos Especiales. Oficina Gestora de Impuestos Especiales"
    },
    {
        "codigo":"17801",
        "nombre":"Dependencia de Aduanas e Impuestos Especiales de Girona: con sede en La Jonquera"
    },
    {
        "codigo":"18600",
        "nombre":"Dependencia de Aduanas e Impuestos Especiales de Granada (incluida la Oficina Gestora de Impuestos Especiales)"
    },
    {
        "codigo":"18801",
        "nombre":"Administración de Aduanas e Impuestos Especiales de Motril"
    },
    {
        "codigo":"19801",
        "nombre":"Dependencia de Aduanas e Impuestos Especiales de Guadalajara"
    },
    {
        "codigo":"20801",
        "nombre":"Dependencia de Aduanas e Impuestos Especiales de Gipuzkoa (Sede Irún)"
    },
    {
        "codigo":"21801",
        "nombre":"Dependencia de Aduanas e Impuestos Especiales de Huelva"
    },
    {
        "codigo":"22801",
        "nombre":"Dependencia de Aduanas e Impuestos Especiales de Huesca"
    },
    {
        "codigo":"23801",
        "nombre":"Dependencia de Aduanas e Impuestos Especiales de Jaén"
    },
    {
        "codigo":"24801",
        "nombre":"Dependencia de Aduanas e Impuestos Especiales de León"
    },
    {
        "codigo":"25801",
        "nombre":"Dependencia de Aduanas e Impuestos Especiales de Lleida: con sede en La Farga de Moles, salvo la Oficina Gestora que está en la sede de la Delegación de Lleida"
    },
    {
        "codigo":"26801",
        "nombre":"Dependencia Regional de Aduanas e Impuestos Especiales de La Rioja"
    },
    {
        "codigo":"27010",
        "nombre":"Aduana de Ribadeo"
    },
    {
        "codigo":"27801",
        "nombre":"Dependencia de Aduanas e Impuestos Especiales de Lugo (incluida la Oficina Gestora de Impuestos Especiales)"
    },
    {
        "codigo":"28001",
        "nombre":"Administración de Aduanas e Impuestos Especiales de Madrid"
    },
    {
        "codigo":"28801",
        "nombre":"Dependencia Regional de Aduanas e Impuestos Especiales de Madrid (incluida la Oficina Gestora de Impuestos Especiales)"
    },
    {
        "codigo":"29001",
        "nombre":"Administración de Aduanas e Impuestos Especiales del Aeropuerto de Málaga-Costa del Sol"
    },
    {
        "codigo":"29801",
        "nombre":"Dependencia de Aduanas e Impuestos Especiales de Málaga (incluida la Oficina Gestora de Impuestos Especiales)"
    },
    {
        "codigo":"30051",
        "nombre":"Administración de Aduanas e Impuestos Especiales de Murcia-carretera"
    },
    {
        "codigo":"30801",
        "nombre":"Dependencia Regional de Aduanas e Impuestos Especiales de Murcia (incluida la Oficina Gestora de Impuestos Especiales)"
    },
    {
        "codigo":"31801",
        "nombre":"Dependencia Regional de Aduanas e Impuestos Especiales de Navarra (Sede Imárcoain)"
    },
    {
        "codigo":"31801",
        "nombre":"Dependencia Regional de Aduanas e Impuestos Especiales de Navarra (Sede Yanguas y Miranda)"
    },
    {
        "codigo":"32801",
        "nombre":"Dependencia de Aduanas e Impuestos Especiales de Ourense"
    },
    {
        "codigo":"33801",
        "nombre":"Dependencia Regional de Aduanas e Impuestos Especiales de Asturias (incluida la Oficina Gestora de Impuestos Especiales)"
    },
    {
        "codigo":"33802",
        "nombre":"Administración de Aduanas e Impuestos Especiales de Avilés"
    },
    {
        "codigo":"34801",
        "nombre":"Dependencia de Aduanas e Impuestos Especiales de Palencia"
    },
    {
        "codigo":"35001",
        "nombre":"Administración de Aduanas e Impuestos Especiales del Aeropuerto de Gran Canaria: con sede en Telde"
    },
    {
        "codigo":"35030",
        "nombre":"Administración de Aduanas e Impuestos Especiales de Puerto del Rosario: con sede en Fuerteventura"
    },
    {
        "codigo":"35091",
        "nombre":"Administración de Aduanas e Impuestos Especiales de Las Palmas de Gran Canaria-Marítima"
    },
    {
        "codigo":"35801",
        "nombre":"Dependencia Regional de Aduanas e Impuestos Especiales de Canarias (incluida la Oficina Gestora de Impuestos Especiales)"
    },
    {
        "codigo":"35802",
        "nombre":"Administración de Aduanas e Impuestos Especiales de Arrecife: con sede en Lanzarote"
    },
    {
        "codigo":"36031",
        "nombre":"Administración de Aduanas e Impuestos Especiales de Vilagarcia de Arousa"
    },
    {
        "codigo":"36801",
        "nombre":"Dependencia de Aduanas e Impuestos Especiales de Pontevedra (incluida la Oficina Gestora de Impuestos Especiales)"
    },
    {
        "codigo":"37801",
        "nombre":"Dependencia de Aduanas e Impuestos Especiales de Salamanca"
    },
    {
        "codigo":"38001",
        "nombre":"Administración de Aduanas e Impuestos Especiales del Aeropuerto de Santa Cruz de Tenerife Sur-Reina Sofía: con sede en Granadilla de Abona"
    },
    {
        "codigo":"38003",
        "nombre":"Administración de Aduanas e Impuestos Especiales del Aeropuerto de Santa Cruz de Tenerife Norte - Ciudad de La Laguna: con sede en La Laguna"
    },
    {
        "codigo":"38020",
        "nombre":"Administración de Aduanas e Impuestos Especiales de Santa Cruz de la Palma: con sede en La Palma"
    },
    {
        "codigo":"38801",
        "nombre":"Dependencia de Aduanas e Impuestos Especiales de Santa Cruz de Tenerife (incluida la Oficina Gestora de Impuestos Especiales)"
    },
    {
        "codigo":"39801",
        "nombre":"Dependencia Regional de Aduanas e Impuestos Especiales de Cantabria"
    },
    {
        "codigo":"40801",
        "nombre":"Dependencia de Aduanas e Impuestos Especiales de Segovia"
    },
    {
        "codigo":"41801",
        "nombre":"Dependencia Regional de Aduanas e Impuestos Especiales de Andalucía, Ceuta y Melilla"
    },
    {
        "codigo":"42801",
        "nombre":"Dependencia de Aduanas e Impuestos Especiales de Soria"
    },
    {
        "codigo":"43801",
        "nombre":"Dependencia de Aduanas e Impuestos Especiales de Tarragona (incluida la Oficina Gestora de Impuestos Especiales)"
    },
    {
        "codigo":"44801",
        "nombre":"Dependencia de Aduanas e Impuestos Especiales de Teruel"
    },
    {
        "codigo":"45801",
        "nombre":"Dependencia Regional de Aduanas e Impuestos Especiales de Castilla-La Mancha (incluida la Oficina Gestora de Impuestos Especiales)"
    },
    {
        "codigo":"46011",
        "nombre":"Administración de Aduanas e Impuestos Especiales de Valencia-marítima"
    },
    {
        "codigo":"46021",
        "nombre":"Administración de Aduanas e Impuestos Especiales de Sagunto\/Sagunt"
    },
    {
        "codigo":"46801",
        "nombre":"Administración de Aduanas e Impuestos Especiales del Aeropuerto de Valencia-Manises"
    },
    {
        "codigo":"47801",
        "nombre":"Dependencia Regional de Aduanas e Impuestos Especiales de Castilla y León"
    },
    {
        "codigo":"48001",
        "nombre":"Administración de Aduanas e Impuestos Especiales del Aeropuerto de Bilbao (Sede Sondika)"
    },
    {
        "codigo":"48011",
        "nombre":"Administración de Aduanas e Impuestos Especiales de Bilbao-marítima (Sede Santurtzi)"
    },
    {
        "codigo":"48042",
        "nombre":"Administración de Aduanas e Impuestos Especiales de Bilbao-carretera-Aparcabisa"
    },
    {
        "codigo":"48801",
        "nombre":"Dependencia Regional de Aduanas e Impuestos Especiales del País Vasco"
    },
    {
        "codigo":"49801",
        "nombre":"Dependencia de Aduanas e Impuestos Especiales de Zamora"
    },
    {
        "codigo":"50001",
        "nombre":"Administración de Aduanas e Impuestos Especiales del Aeropuerto de Zaragoza"
    },
    {
        "codigo":"50801",
        "nombre":"Dependencia Regional de Aduanas e Impuestos Especiales de Aragón (incluida la Oficina Gestora de Impuestos Especiales)"
    },
    {
        "codigo":"51801",
        "nombre":"Dependencia de Aduanas e Impuestos Especiales de Cartagena"
    },
    {
        "codigo":"52801",
        "nombre":"Dependencia de Aduanas e Impuestos Especiales de Gijón"
    },
    {
        "codigo":"53801",
        "nombre":"Dependencia de Aduanas e Impuestos Especiales de Jerez de la Frontera"
    },
    {
        "codigo":"54801",
        "nombre":"Dependencia de Aduanas e Impuestos Especiales de Vigo"
    },
    {
        "codigo":"55801",
        "nombre":"Dependencia de Aduanas e Impuestos Especiales de Ceuta"
    },
    {
        "codigo":"56801",
        "nombre":"Dependencia de Aduanas e Impuestos Especiales de Melilla"
    },
    {
        "codigo":"8011",
        "nombre":"Administración de Aduanas e Impuestos Especiales de Barcelona"
    },
    {
        "codigo":"8855",
        "nombre":"Laboratorio Regional de Aduanas de Cataluña"
    },
    {
        "codigo":"01600",
        "nombre":"Delegación Araba\/Álava"
    },
    {
        "codigo":"02037",
        "nombre":"Administración Hellín"
    },
    {
        "codigo":"02069",
        "nombre":"Administración La Roda"
    },
    {
        "codigo":"02600",
        "nombre":"Delegación Albacete"
    },
    {
        "codigo":"03009",
        "nombre":"Administración Alcoi\/Alcoy"
    },
    {
        "codigo":"03031",
        "nombre":"Administración Benidorm"
    },
    {
        "codigo":"03063",
        "nombre":"Administración Dénia"
    },
    {
        "codigo":"03065",
        "nombre":"Administración Elche"
    },
    {
        "codigo":"03066",
        "nombre":"Administración Elda"
    },
    {
        "codigo":"03099",
        "nombre":"Administración Orihuela"
    },
    {
        "codigo":"03140",
        "nombre":"Administración Villena"
    },
    {
        "codigo":"03600",
        "nombre":"Delegación Alicante\/Alacant"
    },
    {
        "codigo":"03600",
        "nombre":"Dependencias de Inspección, Gestión, Recaudación e Informática de Alicante\/Alacant"
    },
    {
        "codigo":"03601",
        "nombre":"Administración Alicante\/Alacant"
    },
    {
        "codigo":"04053",
        "nombre":"Administración Huercal-Overa"
    },
    {
        "codigo":"04104",
        "nombre":"Administración El Ejido"
    },
    {
        "codigo":"04600",
        "nombre":"Delegación Almería"
    },
    {
        "codigo":"05600",
        "nombre":"Delegación Ávila"
    },
    {
        "codigo":"06044",
        "nombre":"Administración Don Benito"
    },
    {
        "codigo":"06083",
        "nombre":"Administración Mérida"
    },
    {
        "codigo":"06158",
        "nombre":"Administración Zafra"
    },
    {
        "codigo":"06600",
        "nombre":"Delegación Especial de Extremadura"
    },
    {
        "codigo":"07026",
        "nombre":"Administración Eivissa-Formentera"
    },
    {
        "codigo":"07027",
        "nombre":"Administración Inca"
    },
    {
        "codigo":"07032",
        "nombre":"Administración Menorca"
    },
    {
        "codigo":"07033",
        "nombre":"Administración Manacor"
    },
    {
        "codigo":"07600",
        "nombre":"Delegación Especial de Illes Balears"
    },
    {
        "codigo":"07601",
        "nombre":"Administración de Palma de Mallorca"
    },
    {
        "codigo":"07611",
        "nombre":"Inspección Regional de Illes Balears"
    },
    {
        "codigo":"07852",
        "nombre":"Dependencia Regional de Recaudación de Illes Balears"
    },
    {
        "codigo":"08006",
        "nombre":"Administración Arenys de Mar"
    },
    {
        "codigo":"08015",
        "nombre":"Administración Badalona"
    },
    {
        "codigo":"08022",
        "nombre":"Administración Berga"
    },
    {
        "codigo":"08072",
        "nombre":"Administración Cornellà de Llobregat"
    },
    {
        "codigo":"08095",
        "nombre":"Administración Granollers"
    },
    {
        "codigo":"08100",
        "nombre":"Administración L'Hospitalet de Llobregat"
    },
    {
        "codigo":"08101",
        "nombre":"Administración Igualada"
    },
    {
        "codigo":"08112",
        "nombre":"Administración Manresa"
    },
    {
        "codigo":"08120",
        "nombre":"Administración Mataró"
    },
    {
        "codigo":"08186",
        "nombre":"Administración Sabadell"
    },
    {
        "codigo":"08204",
        "nombre":"Administración Sant Cugat del Vallès"
    },
    {
        "codigo":"08210",
        "nombre":"Administración Sant Feliu de Llobregat"
    },
    {
        "codigo":"08245",
        "nombre":"Administración Sta. Coloma de Gramenet"
    },
    {
        "codigo":"08279",
        "nombre":"Administración Terrassa"
    },
    {
        "codigo":"08299",
        "nombre":"Administración Vic"
    },
    {
        "codigo":"08306",
        "nombre":"Administración Vilafranca del Penedès"
    },
    {
        "codigo":"08308",
        "nombre":"Administración Vilanova i la Geltrú"
    },
    {
        "codigo":"08600",
        "nombre":"Delegación Especial de Cataluña"
    },
    {
        "codigo":"08602",
        "nombre":"Administración Colom"
    },
    {
        "codigo":"08605",
        "nombre":"Administración Via Augusta"
    },
    {
        "codigo":"08606",
        "nombre":"Administración Horta"
    },
    {
        "codigo":"08608",
        "nombre":"Administración Poblenou"
    },
    {
        "codigo":"08610",
        "nombre":"Administración Letamendi"
    },
    {
        "codigo":"08850",
        "nombre":"Inspección Regional de Cataluña, sede Barcelona"
    },
    {
        "codigo":"08850",
        "nombre":"Inspección Regional de Cataluña, sede Principal"
    },
    {
        "codigo":"08851",
        "nombre":"Dependencia Regional de Informática de Cataluña"
    },
    {
        "codigo":"08852",
        "nombre":"Dependencia Regional de Recaudación de Cataluña"
    },
    {
        "codigo":"08853",
        "nombre":"Dependencia Regional de Gestión Tributaria de Cataluña"
    },
    {
        "codigo":"09018",
        "nombre":"Administración Aranda de Duero"
    },
    {
        "codigo":"09224",
        "nombre":"Administración Miranda de Ebro"
    },
    {
        "codigo":"09600",
        "nombre":"Delegación Burgos"
    },
    {
        "codigo":"10134",
        "nombre":"Administración Navalmoral de la Mata"
    },
    {
        "codigo":"10151",
        "nombre":"Administración Plasencia"
    },
    {
        "codigo":"10199",
        "nombre":"Administración Trujillo"
    },
    {
        "codigo":"10600",
        "nombre":"Delegación Cáceres"
    },
    {
        "codigo":"11004",
        "nombre":"Administración Algeciras"
    },
    {
        "codigo":"11015",
        "nombre":"Administración Chiclana de la Frontera"
    },
    {
        "codigo":"11027",
        "nombre":"Administración Puerto de Santa María"
    },
    {
        "codigo":"11032",
        "nombre":"Administración Sanlúcar de Barrameda"
    },
    {
        "codigo":"11033",
        "nombre":"Administración San Roque"
    },
    {
        "codigo":"11038",
        "nombre":"Administración Ubrique"
    },
    {
        "codigo":"11600",
        "nombre":"Delegación Cádiz"
    },
    {
        "codigo":"12135",
        "nombre":"Administración Vila-real"
    },
    {
        "codigo":"12138",
        "nombre":"Administración Vinaròs"
    },
    {
        "codigo":"12600",
        "nombre":"Delegación Castellón\/Castelló"
    },
    {
        "codigo":"13005",
        "nombre":"Administración Alcázar de San Juan"
    },
    {
        "codigo":"13071",
        "nombre":"Administración Puertollano"
    },
    {
        "codigo":"13087",
        "nombre":"Administración Valdepeñas"
    },
    {
        "codigo":"13600",
        "nombre":"Delegación Ciudad Real"
    },
    {
        "codigo":"14038",
        "nombre":"Administración Lucena"
    },
    {
        "codigo":"14042",
        "nombre":"Administración Montilla"
    },
    {
        "codigo":"14052",
        "nombre":"Administración Peñarroya-Pueblonuevo"
    },
    {
        "codigo":"14054",
        "nombre":"Administración Pozoblanco"
    },
    {
        "codigo":"14600",
        "nombre":"Delegación Córdoba"
    },
    {
        "codigo":"15009",
        "nombre":"Administración Betanzos"
    },
    {
        "codigo":"15019",
        "nombre":"Administración Carballo"
    },
    {
        "codigo":"15023",
        "nombre":"Administración Cee"
    },
    {
        "codigo":"15037",
        "nombre":"Administración Ferrol"
    },
    {
        "codigo":"15062",
        "nombre":"Administración Ortigueira"
    },
    {
        "codigo":"15074",
        "nombre":"Administración Ribeira"
    },
    {
        "codigo":"15079",
        "nombre":"Administración Santiago de Compostela"
    },
    {
        "codigo":"15600",
        "nombre":"Delegación Especial de Galicia"
    },
    {
        "codigo":"15601",
        "nombre":"Administración A Coruña"
    },
    {
        "codigo":"16212",
        "nombre":"Administración Tarancón"
    },
    {
        "codigo":"16600",
        "nombre":"Delegación Cuenca"
    },
    {
        "codigo":"17025",
        "nombre":"Administración La Bisbal"
    },
    {
        "codigo":"17072",
        "nombre":"Administración Figueres"
    },
    {
        "codigo":"17121",
        "nombre":"Administración Olot"
    },
    {
        "codigo":"17600",
        "nombre":"Delegación Girona"
    },
    {
        "codigo":"18024",
        "nombre":"Administración Baza"
    },
    {
        "codigo":"18091",
        "nombre":"Administración Guadix"
    },
    {
        "codigo":"18123",
        "nombre":"Administración Loja"
    },
    {
        "codigo":"18142",
        "nombre":"Administración Motril"
    },
    {
        "codigo":"18150",
        "nombre":"Administración Órgiva"
    },
    {
        "codigo":"18600",
        "nombre":"Delegación Granada"
    },
    {
        "codigo":"19600",
        "nombre":"Delegación Guadalajara"
    },
    {
        "codigo":"20600",
        "nombre":"Delegación Gipuzkoa"
    },
    {
        "codigo":"21007",
        "nombre":"Administración Aracena"
    },
    {
        "codigo":"21010",
        "nombre":"Administración Ayamonte"
    },
    {
        "codigo":"21054",
        "nombre":"Administración La Palma del Condado"
    },
    {
        "codigo":"21600",
        "nombre":"Delegación Huelva"
    },
    {
        "codigo":"22218",
        "nombre":"Administración Monzón"
    },
    {
        "codigo":"22600",
        "nombre":"Delegación Huesca"
    },
    {
        "codigo":"23005",
        "nombre":"Administración Andújar"
    },
    {
        "codigo":"23055",
        "nombre":"Administración Linares"
    },
    {
        "codigo":"23092",
        "nombre":"Administración Úbeda"
    },
    {
        "codigo":"23095",
        "nombre":"Administración Villacarrillo"
    },
    {
        "codigo":"23600",
        "nombre":"Delegación Jaén"
    },
    {
        "codigo":"24009",
        "nombre":"Administración Astorga"
    },
    {
        "codigo":"24118",
        "nombre":"Administración Ponferrada"
    },
    {
        "codigo":"24600",
        "nombre":"Delegación León"
    },
    {
        "codigo":"25252",
        "nombre":"Administración La Seu d'Urgell"
    },
    {
        "codigo":"25272",
        "nombre":"Administración Tàrrega"
    },
    {
        "codigo":"25600",
        "nombre":"Delegación Lleida"
    },
    {
        "codigo":"26036",
        "nombre":"Administración Calahorra"
    },
    {
        "codigo":"26071",
        "nombre":"Administración Haro"
    },
    {
        "codigo":"26600",
        "nombre":"Delegación Especial de La Rioja"
    },
    {
        "codigo":"27019",
        "nombre":"Administración Foz"
    },
    {
        "codigo":"27031",
        "nombre":"Administración Monforte de Lemos"
    },
    {
        "codigo":"27600",
        "nombre":"Delegación Lugo"
    },
    {
        "codigo":"28005",
        "nombre":"Administración Alcalá de Henares"
    },
    {
        "codigo":"28006",
        "nombre":"Administración Alcobendas"
    },
    {
        "codigo":"28007",
        "nombre":"Administración Alcorcón"
    },
    {
        "codigo":"28013",
        "nombre":"Administración Aranjuez"
    },
    {
        "codigo":"28014",
        "nombre":"Administración Arganda"
    },
    {
        "codigo":"28045",
        "nombre":"Administración Colmenar Viejo"
    },
    {
        "codigo":"28054",
        "nombre":"Administración El Escorial"
    },
    {
        "codigo":"28058",
        "nombre":"Administración Fuenlabrada"
    },
    {
        "codigo":"28065",
        "nombre":"Administración Getafe"
    },
    {
        "codigo":"28074",
        "nombre":"Administración Leganés"
    },
    {
        "codigo":"28092",
        "nombre":"Administración Móstoles"
    },
    {
        "codigo":"28115",
        "nombre":"Administración Pozuelo de Alarcón"
    },
    {
        "codigo":"28148",
        "nombre":"Administración Torrejón de Ardoz"
    },
    {
        "codigo":"28600",
        "nombre":"Delegación Especial de Madrid"
    },
    {
        "codigo":"28602",
        "nombre":"Administración Madrid Suroeste"
    },
    {
        "codigo":"28603",
        "nombre":"Administración Montalbán"
    },
    {
        "codigo":"28604",
        "nombre":"Administración Ciudad Lineal    CERRADA"
    },
    {
        "codigo":"28606",
        "nombre":"Administración Madrid Norte"
    },
    {
        "codigo":"28612",
        "nombre":"Administración María de Molina"
    },
    {
        "codigo":"28613",
        "nombre":"Administración Madrid Este (Sede San Blas)"
    },
    {
        "codigo":"28614",
        "nombre":"Administración Madrid Este (Sede Vinateros)"
    },
    {
        "codigo":"28616",
        "nombre":"Administración Guzmán el Bueno"
    },
    {
        "codigo":"29012",
        "nombre":"Administración Álora"
    },
    {
        "codigo":"29015",
        "nombre":"Administración Antequera"
    },
    {
        "codigo":"29069",
        "nombre":"Administración Marbella"
    },
    {
        "codigo":"29084",
        "nombre":"Administración Ronda"
    },
    {
        "codigo":"29094",
        "nombre":"Administración Vélez-Málaga"
    },
    {
        "codigo":"29103",
        "nombre":"Administración Torremolinos"
    },
    {
        "codigo":"29600",
        "nombre":"Delegación de Málaga. Dependencias de Informática, Secretaría General, Servicio Jurídico y DCGC"
    },
    {
        "codigo":"29600",
        "nombre":"Dependencia Regional de Inspección"
    },
    {
        "codigo":"29600",
        "nombre":"Dependencias de Gestión y Recaudación (incluida Unidad de Información y Asistencia al contribuyente)"
    },
    {
        "codigo":"30019",
        "nombre":"Administración Cieza"
    },
    {
        "codigo":"30024",
        "nombre":"Administración Lorca"
    },
    {
        "codigo":"30029",
        "nombre":"Administración Mula"
    },
    {
        "codigo":"30600",
        "nombre":"Delegación Especial de Murcia"
    },
    {
        "codigo":"30601",
        "nombre":"Administración de Murcia"
    },
    {
        "codigo":"31600",
        "nombre":"Delegación Especial de Navarra"
    },
    {
        "codigo":"32010",
        "nombre":"Administración Barco de Valdeorras"
    },
    {
        "codigo":"32020",
        "nombre":"Administración Carballiño"
    },
    {
        "codigo":"32025",
        "nombre":"Administración Celanova"
    },
    {
        "codigo":"32086",
        "nombre":"Administración Verín"
    },
    {
        "codigo":"32600",
        "nombre":"Delegación Ourense"
    },
    {
        "codigo":"33004",
        "nombre":"Administración Avilés"
    },
    {
        "codigo":"33011",
        "nombre":"Administración Cangas de Narcea"
    },
    {
        "codigo":"33031",
        "nombre":"Administración Langreo"
    },
    {
        "codigo":"33034",
        "nombre":"Administración Luarca"
    },
    {
        "codigo":"33037",
        "nombre":"Administración Mieres"
    },
    {
        "codigo":"33600",
        "nombre":"Delegación Especial de Asturias"
    },
    {
        "codigo":"33600",
        "nombre":"Delegación Especial de Asturias (Oficina de atención al público)"
    },
    {
        "codigo":"34004",
        "nombre":"Administración Aguilar de Campoo"
    },
    {
        "codigo":"34600",
        "nombre":"Delegación Palencia"
    },
    {
        "codigo":"35004",
        "nombre":"Administración Lanzarote"
    },
    {
        "codigo":"35010",
        "nombre":"Administración Santa María de Guía"
    },
    {
        "codigo":"35018",
        "nombre":"Administración Fuerteventura"
    },
    {
        "codigo":"35020",
        "nombre":"Administración San Bartolomé de Tirajana"
    },
    {
        "codigo":"35600",
        "nombre":"Delegación Especial de Canarias"
    },
    {
        "codigo":"35601",
        "nombre":"Administración Las Palmas de Gran Canaria"
    },
    {
        "codigo":"36017",
        "nombre":"Administración A Estrada"
    },
    {
        "codigo":"36042",
        "nombre":"Administración Ponteareas"
    },
    {
        "codigo":"36055",
        "nombre":"Administración Tui"
    },
    {
        "codigo":"36060",
        "nombre":"Administración Vilagarcía de Arousa"
    },
    {
        "codigo":"36600",
        "nombre":"Delegación Pontevedra"
    },
    {
        "codigo":"37046",
        "nombre":"Administración Béjar"
    },
    {
        "codigo":"37107",
        "nombre":"Administración Ciudad Rodrigo"
    },
    {
        "codigo":"37600",
        "nombre":"Delegación Salamanca"
    },
    {
        "codigo":"38006",
        "nombre":"Administración Arona"
    },
    {
        "codigo":"38023",
        "nombre":"Administración La Laguna"
    },
    {
        "codigo":"38028",
        "nombre":"Administración Puerto de la Cruz"
    },
    {
        "codigo":"38036",
        "nombre":"Administración La Gomera"
    },
    {
        "codigo":"38037",
        "nombre":"Administración La Palma"
    },
    {
        "codigo":"38048",
        "nombre":"Administración El Hierro"
    },
    {
        "codigo":"38600",
        "nombre":"Delegación Santa Cruz de Tenerife"
    },
    {
        "codigo":"39035",
        "nombre":"Administración Laredo"
    },
    {
        "codigo":"39059",
        "nombre":"Administración Reinosa"
    },
    {
        "codigo":"39087",
        "nombre":"Administración Torrelavega"
    },
    {
        "codigo":"39600",
        "nombre":"Delegación Especial de Cantabria"
    },
    {
        "codigo":"40600",
        "nombre":"Delegación Segovia"
    },
    {
        "codigo":"41039",
        "nombre":"Administración Écija"
    },
    {
        "codigo":"41055",
        "nombre":"Administración Lora del Río"
    },
    {
        "codigo":"41065",
        "nombre":"Administración Morón de la Frontera"
    },
    {
        "codigo":"41068",
        "nombre":"Administración Osuna"
    },
    {
        "codigo":"41095",
        "nombre":"Administración Utrera"
    },
    {
        "codigo":"41600",
        "nombre":"Delegación Especial de Andalucía, sede Ministro Indalecio Prieto"
    },
    {
        "codigo":"41603",
        "nombre":"Administración Heliópolis"
    },
    {
        "codigo":"41604",
        "nombre":"Administración Nervión"
    },
    {
        "codigo":"41605",
        "nombre":"Administración Sevilla Centro"
    },
    {
        "codigo":"41850",
        "nombre":"Dependencia Regional de Inspección Financiera y Tributaria de Andalucía, Ceuta y Melilla (sede Avenida de Las Razas)"
    },
    {
        "codigo":"42600",
        "nombre":"Delegación Soria"
    },
    {
        "codigo":"43125",
        "nombre":"Administración Reus"
    },
    {
        "codigo":"43157",
        "nombre":"Administración Tortosa"
    },
    {
        "codigo":"43600",
        "nombre":"Delegación Tarragona"
    },
    {
        "codigo":"44013",
        "nombre":"Administración Alcañiz"
    },
    {
        "codigo":"44600",
        "nombre":"Delegación Teruel"
    },
    {
        "codigo":"45143",
        "nombre":"Administración Quintanar de la Orden"
    },
    {
        "codigo":"45166",
        "nombre":"Administración Talavera de la Reina"
    },
    {
        "codigo":"4560",
        "nombre":"Dependencia Regional de Inspección de Castilla-La Mancha"
    },
    {
        "codigo":"45600",
        "nombre":"Delegación Especial de Castilla-La Mancha"
    },
    {
        "codigo":"45600",
        "nombre":"Delegación Especial de Castilla-La Mancha (Oficina de atención al público)"
    },
    {
        "codigo":"46017",
        "nombre":"Administración Alzira"
    },
    {
        "codigo":"46096",
        "nombre":"Administración Catarroja"
    },
    {
        "codigo":"46133",
        "nombre":"Administración Gandia"
    },
    {
        "codigo":"46147",
        "nombre":"Administración Xàtiva"
    },
    {
        "codigo":"46149",
        "nombre":"Administración Llíria"
    },
    {
        "codigo":"46161",
        "nombre":"Administración Manises"
    },
    {
        "codigo":"46173",
        "nombre":"Administración Moncada"
    },
    {
        "codigo":"46215",
        "nombre":"Administración Requena"
    },
    {
        "codigo":"46222",
        "nombre":"Administración Sagunto"
    },
    {
        "codigo":"46237",
        "nombre":"Administración Sueca"
    },
    {
        "codigo":"46246",
        "nombre":"Administración Torrent"
    },
    {
        "codigo":"46600",
        "nombre":"Delegación Especial de la Comunitat Valenciana"
    },
    {
        "codigo":"46601",
        "nombre":"Administración Blasco Ibañez"
    },
    {
        "codigo":"46603",
        "nombre":"Administración Guillem de Castro"
    },
    {
        "codigo":"47086",
        "nombre":"Administración Medina del Campo"
    },
    {
        "codigo":"47600",
        "nombre":"Delegación Especial de Castilla y León"
    },
    {
        "codigo":"48600",
        "nombre":"Delegación Especial del País Vasco"
    },
    {
        "codigo":"49023",
        "nombre":"Administración Benavente"
    },
    {
        "codigo":"49600",
        "nombre":"Delegación Zamora"
    },
    {
        "codigo":"50067",
        "nombre":"Administración Calatayud"
    },
    {
        "codigo":"50095",
        "nombre":"Administración Ejea de los Caballeros"
    },
    {
        "codigo":"50600",
        "nombre":"Delegación Especial de Aragón"
    },
    {
        "codigo":"50601",
        "nombre":"Administración Arrabal-Puente Santiago"
    },
    {
        "codigo":"50602",
        "nombre":"Administración Albareda"
    },
    {
        "codigo":"51600",
        "nombre":"Delegación Cartagena"
    },
    {
        "codigo":"52012",
        "nombre":"Administración Cangas de Onís"
    },
    {
        "codigo":"52600",
        "nombre":"Delegación Gijón"
    },
    {
        "codigo":"53600",
        "nombre":"Delegación Jerez"
    },
    {
        "codigo":"54600",
        "nombre":"Delegación Vigo"
    },
    {
        "codigo":"55600",
        "nombre":"Delegación Ceuta"
    },
    {
        "codigo":"56600",
        "nombre":"Delegación Melilla"
    },
    {
        "codigo":"5850",
        "nombre":"Inspección Regional de Cataluña, sede Lleida"
    },
    {
        "codigo":"7850",
        "nombre":"Inspección Regional de Cataluña, sede Girona"
    },
    {
        "codigo":"06850",
        "nombre":"Unidad de Gestión de Grandes Empresas (UGGE) de Extremadura"
    },
    {
        "codigo":"07850",
        "nombre":"Unidad de Gestión de Grandes Empresas (UGGE) de Illes Balears"
    },
    {
        "codigo":"08950",
        "nombre":"Sede de Barcelona de la Delegación Central de Grandes Contribuyentes"
    },
    {
        "codigo":"15850",
        "nombre":"Unidad de Gestión de Grandes Empresas (UGGE) de Galicia"
    },
    {
        "codigo":"26850",
        "nombre":"Unidad de Gestión de Grandes Empresas (UGGE) de La Rioja"
    },
    {
        "codigo":"28850",
        "nombre":"Unidad de Gestión de Grandes Empresas (UGGE) de Madrid"
    },
    {
        "codigo":"28950",
        "nombre":"Sede de Madrid de la Delegación Central de Grandes Contribuyentes"
    },
    {
        "codigo":"30850",
        "nombre":"Unidad de Gestión de Grandes Empresas (UGGE) de Murcia"
    },
    {
        "codigo":"31850",
        "nombre":"Unidad de Gestión de Grandes Empresas (UGGE) de Navarra"
    },
    {
        "codigo":"35850",
        "nombre":"Unidad de Gestión de Grandes Empresas (UGGE) de Canarias"
    },
    {
        "codigo":"39850",
        "nombre":"Unidad de Gestión de Grandes Empresas (UGGE) de Cantabria"
    },
    {
        "codigo":"41850",
        "nombre":"Unidad de Gestión de Grandes Empresas (UGGE) de Andalucía, Ceuta y Melilla"
    },
    {
        "codigo":"45850",
        "nombre":"Unidad de Gestión de Grandes Empresas (UGGE) de Castilla-La Mancha"
    },
    {
        "codigo":"46850",
        "nombre":"Unidad de Gestión de Grandes Empresas (UGGE) de Valencia"
    },
    {
        "codigo":"47850",
        "nombre":"Unidad de Gestión de Grandes Empresas (UGGE) de Castilla-León"
    },
    {
        "codigo":"48850",
        "nombre":"Unidad de Gestión de Grandes Empresas (UGGE) de País Vasco"
    },
    {
        "codigo":"50850",
        "nombre":"Unidad de Gestión de Grandes Empresas (UGGE) de Aragón"
    },
    {
        "codigo":"8850",
        "nombre":"Unidad de Gestión de Grandes Empresas (UGGE) de Cataluña"
    },
    {
        "codigo":"00206",
        "nombre":"Oficina Nacional de Gestión Tributaria"
    },
    {
        "codigo":"00206",
        "nombre":"Oficina Nacional de Gestión Tributaria"
    }
]